import { useRoutes } from 'react-router-dom';

// routes
import LoginRoutes from './loginRoutes';
import MainRoutes from './mainRoutes';
import Page404Routes from './page404Route';
// ==============================|| ROUTING RENDER ||============================== //

export default function ThemeRoutes() {
  return useRoutes([...LoginRoutes, ...MainRoutes, ...Page404Routes]);
}
